













































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { searchByName } from '@/api/common';
import moment from 'moment';
import { QualityColumns } from '@/utils/report';
import { qualityDataList, reportList } from '@/api/report';
import { roleMap } from '@/utils/meeting';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import { mapGetters } from 'vuex';

const contributeLevalMap = {
  1: '看得见',
  2: '看的清',
  3: '投的进'
};

const meetingCategoryMap = {
  1: 'Early',
  2: 'Early Growth',
  3: 'Growth',
  5: 'Late Growth',
  6: 'Seed'
};

const meetingGoalMap = {
  2: 'Onepager',
  3: 'DD Memo(Pre-TS)',
  4: 'DD Memo(Pre-SPA)',
  5: 'DD Memo(Pre交割)',
  7: 'PreLoan'
};

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo'])}
})
class QUALITYREPORT extends Vue {
  userInfo: any;
  QualityColumns: any[] = QualityColumns;
  requestData: any = {};
  height: number = 0;
  data: any[] = [];
  contributeLevalMap: object = contributeLevalMap;
  meetingCategoryMap: object = meetingCategoryMap;
  meetingGoalMap: object = meetingGoalMap;
  roleMap: object = roleMap;
  DLNameList: any[] = [];
  dl: string = '';
  memberNameList: any[] = [];
  contributor: string = '';
  roleList: any[] = [];
  role: string = '';
  companyName: string = '';
  current: number = 1;
  page: number = 1;
  pageSize: number = 20;
  total: number = 0;
  hasPermission: boolean = false;
  pageSizeOptions: any[] = ['10', '20', '50', '100', '200'];

  mounted() {
    this.height = window.innerHeight - 400;
    window.onresize = () => {
      return (() => {
        this.height = window.innerHeight - 400;
      })();
    };
    this.getPermission();
    this.getList();
    this.getSelects();
    this.getRoleList();
  }

  async getPermission() {
    try {
      let res = await reportList();
      if (res.code === 200) {
        const exportList = res.data.filter(_ => _.id === 8)[0].export.map(_ => _.id);
        const { id } = this.userInfo || {};
        this.hasPermission = exportList.indexOf(id) > -1;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getList(flag = false) {
    try {
      let res = await qualityDataList({
        companyName: this.companyName,
        role: this.role,
        dl: this.dl,
        contributor: this.contributor,
        page: this.page,
        pageSize: this.pageSize
      });
      if (res.code === 200) {
        this.total = res.data.total;
        let list = res.data.list || [];
        this.getData(list);
        console.log(this.data);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getSelects() {
    try {
      let res = await searchByName();
      if (res.code === 200) {
        this.DLNameList = res.data.list.slice(0);
        this.memberNameList = res.data.list.slice(0);
        this.DLNameList.unshift({ id: '', nickname: '全部项目负责人' });
        this.memberNameList.unshift({ id: '', nickname: '全部成员' });
      }
    } catch (err) {
      console.log(err);
    }
  }

  getRoleList() {
    this.roleList.push({ id: '', role: '全部角色' });
    Object.keys(this.roleMap).forEach(key => {
      this.roleList.push({ id: key, role: this.roleMap[key] });
    });
  }

  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  getData(list) {
    list.forEach(e => {
      if (e.contributorList) {
        e.contributorList.forEach((item, index) => {
          this.data.push({
            ...e,
            scorers: item.scorers,
            companyRowSpan: index === 0 ? e.contributorList.length : 0,
            nickname: item.nickname,
            role: item.role,
            leaderEvaluate: item.leaderEvaluate,
            contributeLevel: item.contributeLevel,
            contribution: item.contribution,
            time: e.meetingDate ? moment(e.meetingDate).format('YYYY-MM') : '',
            meetingCategoryStr: this.meetingCategoryMap[e.meetingCategory],
            meetingGoalStr: this.meetingGoalMap[e.meetingGoal],
            contributeLevelStr: this.contributeLevalMap[item.contributeLevel],
            roleStr: this.roleMap[item.role]
          });
        });
      } else {
        this.data.push({
          ...e,
          time: e.meetingDate ? moment(e.meetingDate).format('YYYY-MM') : '',
          companyRowSpan: 1
        });
      }
    });
  }

  onShowSizeChange(current, pageSize) {
    this.pageSize = pageSize;
    this.initPage();
  }

  changePage(page, pageSize) {
    this.page = page;
    this.data = [];
    this.getList();
  }

  initPage() {
    this.current = 1;
    this.page = 1;
    this.data = [];
    this.getList();
  }

  queryList() {
    this.initPage();
  }

  async exportReport() {
    try {
      let date = moment(new Date()).format('YYYYMMDD');
      downloadStreamFile('/quality/exportQualityData', '', `品质表打分情况数据报表_${date}`);
    } catch (err) {
      console.log(err);
    }
  }
}
export default QUALITYREPORT;
